export default __webpack_public_path__ + "static/media/General's Gauntlets of Heaven's Pass.928a0b59.jpg";